import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import FieldValue from './FieldValue';

export default function SummaryCompensation({ settlement }) {
  const { values } = useFormikContext();
  const totalAssets = values?.settlement?.pendingRemunerationBalances.reduce((acc, current) => {
    return acc + +current.amount;
  }, 0);
  const parsedTotal = new Intl.NumberFormat('es-CL').format(totalAssets);
  return (
    <>
      <Row className="mb-2 summary__balances_header">
        <Col md={6} className="">
          <strong>Haberes</strong>
        </Col>
        <Col className="col-1 " />
        <Col md={4} className="">
          <strong>Monto</strong>
        </Col>
      </Row>
      <FieldValue label="Indemnización Sustitutiva de Aviso Previo" value={settlement?.priorNoticeCompensation} />
      <FieldValue label="Indemnización Años de Servicio" value={settlement?.compensationYearsService} />
      <FieldValue label="Indemnización Feriado y proporcional" value={settlement?.holidayCompensation} />
      <FieldValue label="Remuneraciones Pendientes" value={parsedTotal} />
      <hr className="mb-2 mt-2 hr-summary-index" />
    </>
  );
}
